import React, { useRef, useEffect, useState } from "react";
import api from "../api";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useLocation } from "react-router-dom";
import "../App.css";

export default function RegisterForm() {
  const location = useLocation();
  const [qrCode, setQrCode] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: location.state?.email || "",
    phone: "",
    collegeId: "",
    stream: "",
    semester: "1",
  });

  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const getSemesterOptions = () => {
    const stream = formData.stream.toLowerCase();

    // Determine the semester limit based on the stream
    let limit = 6; // Default/General limit

    if (stream.includes("b.tech") || stream.includes("btech") || stream.includes("bfa")) {
      limit = 8;
    } else if (stream.includes("m") || stream.includes("masters")) {
      // Note: 'm' is broad; consider using "m." or "mtech/mba"
      // if you find it's catching too many other words.
      limit = 4;
    }

    return Array.from({ length: limit }, (_, i) => (
      <option key={i + 1} value={i + 1}>
        Semester {i + 1}
      </option>
    ));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await api.post("/register", formData);

      if (res.data.success) {
        setQrCode(res.data.qrCode);
        setStudentName(formData.name);
        setDownloadReady(true);
        setMessage("Registered Successfully! Check your QR Code.");
      } else {
        setMessage("Registration failed. Try again.");
      }
    } catch (error) {
      if (error.response && error.response.status === 409) {
        setMessage("You have already registered!!!!");
      } else {
        setMessage("Registration failed. Try again.");
        console.error(error);
      }
    }
  };

  const qrRef = useRef();
  const [downloadReady, setDownloadReady] = useState(false);
  const [studentName, setStudentName] = useState("");

  useEffect(() => {
  if (downloadReady) {
    const name = studentName; // snapshot

    const downloadPDF = async () => {
      const input = qrRef.current;
      const canvas = await html2canvas(input);
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const imgHeight = (imgProps.height * pdfWidth) / imgProps.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, imgHeight);
      pdf.save(`${name.replaceAll(" ", "_")}_QR_Code.pdf`);
    };

    downloadPDF();
  }
}, [downloadReady, studentName]);

  return (
    <div className="form-container">
      <div className="form-box">
        <h2 className="form-title">Fest Registration</h2>
        <form onSubmit={handleSubmit} className="form-body">
          <div className="window-box">
            <input
              name="name"
              placeholder="Full Name"
              className="form-input"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              name="email"
              type="email"
              placeholder="Email"
              className="form-input read-only"
              value={formData.email}
              onChange={handleChange}
              readOnly
            />
            <input
              name="phone"
              placeholder="Phone Number"
              className="form-input"
              value={formData.phone}
              onChange={handleChange}
              required
            />
            <input
              name="collegeId"
              placeholder="College ID / Roll Number"
              className="form-input"
              value={formData.collegeId}
              onChange={handleChange}
              required
            />
            <input
              name="stream"
              placeholder="Stream / Course"
              className="form-input"
              value={formData.stream}
              onChange={handleChange}
              required
            />
            <select
              name="semester"
              className="form-input-select"
              value={formData.semester}
              onChange={handleChange}
            >
              {getSemesterOptions()}
            </select>
            <button type="submit" className="form-button">
              Register
            </button>
          </div>
        </form>

        {qrCode && (
          <div ref={qrRef} className="qr-preview">
            <img src={qrCode} alt="QR Code" className="qr-image" />
            <h3>{studentName}</h3>
          </div>
        )}

        {message && <p className="form-message">{message}</p>}
      </div>
    </div>
  );
}
